import { Injectable, signal } from '@angular/core';

type Dict = Record<string,string>;

const EN: Dict = {
  'register.title': 'Create your account',
  'register.email': 'Email',
  'register.password': 'Password',
  'register.submit': 'Sign up',
  'register.success': 'Registration successful! Check your email.',
  'register.error': 'Registration failed. Please try again.',
  'login.title': 'Sign in'
};

const BG: Dict = {
  'register.title': 'Създай акаунт',
  'register.email': 'Имейл',
  'register.password': 'Парола',
  'register.submit': 'Регистрирай се',
  'register.success': 'Успешна регистрация! Проверете имейла си.',
  'register.error': 'Грешка при регистрация. Опитайте пак.',
  'login.title': 'Влез'
};

@Injectable({ providedIn: 'root' })
export class TranslateService {
  private _lang = signal<'en'|'bg'>('en');
  dicts = { en: EN, bg: BG };

  get current() { return this._lang(); }
  set current(v: 'en'|'bg') { this._lang.set(v); }

  translate(key: string) {
    return this.dicts[this.current][key] ?? key;
  }
}
